import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assist-header-banner',
  templateUrl: './assist-header-banner.component.html',
  styleUrls: ['./assist-header-banner.component.scss']
})
export class AssistHeaderBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
